import { Actions, EventManager, Events } from "../../lib/Events";
import axios from "axios";
import CommonConditions from "@lib/commonConditions";
import { useCallState } from "@/stores/videoCallStateParts/callState";

export default function startEventCollecting() {
  EventManager.rootEventEmitter().on(Events.VideoCallCreated, (payload) => {
    if (payload.ignoreWebRtcRoom) {
      console.log("Ignoring call event collector for rtcId: " + payload.rtcId);
      return;
    }
    const rtcId = payload.rtcId;

    if (!CommonConditions.isAgent(rtcId)) return;

    const scopedEventEmitter = EventManager.getEventEmitter(rtcId);
    const scopedActionEmitter = EventManager.getActionEmitter(rtcId);

    const state = useCallState(rtcId);

    async function sendEvent(name, data = "") {
      console.log("Sending call event " + name + " data:" + data);
      if (state.muteEvents.value) {
        console.log("Mute events is enabled, not sending event " + name);
        return;
      }
      try {
        await axios.post("/api/call/event", {
          rtcId,
          data,
          CallEventTypeName: name,
        });
        console.log("Call event " + name + " sent successfully");
      } catch (e) {
        console.error("Error while sending call event to server");
        console.error(e);
      }
    }

    scopedEventEmitter.on(Events.CallEvent, async (payload) => {
      try {
        const name = payload.name;
        const data = payload.data;
        await sendEvent(name, data);
      } catch (e) {
        console.error("Error while sending call event to server");
        console.error(e);
      }
    });

    scopedEventEmitter.on(Events.ConnectionStateChanged, async (payload) => {
      if (payload == "RTC-CONNECTION-CONNECTED") {
        sendEvent("Connected");
      }

      if (payload == "RTC-CONNECTION-FAILED") {
        sendEvent("ConnectionFailed");
      }

      if (payload == "RTC-CONNECTION-DISCONNECTED") {
        sendEvent("Disconnected");
      }

      if (payload == "ICE-CONNECTION-CONNECTED") {
        sendEvent("IceConnectionConnected");
      }

      if (payload == "ICE-CONNECTION-FAILED") {
        sendEvent("IceConnectionFailed");
      }

      if (payload == "ICE-CONNECTION-DISCONNECTED") {
        sendEvent("IceConnectionDisconnected");
      }
    });

    scopedEventEmitter.on(Events.RecordingStarted, async () => {
      await sendEvent("RecordingStarted");
    });

    scopedActionEmitter.on(Actions.HoldCall, async () => {
      await sendEvent("HoldStarted");
    });

    scopedActionEmitter.on(Actions.ResumeCall, async () => {
      await sendEvent("HoldFinished");
    });

    scopedActionEmitter.on(Actions.HangUp, async (payload) => {
      await sendEvent("Hangup", payload.hangupBy);
    });

    scopedActionEmitter.on(Actions.MuteAudio, async (payload) => {
      if (payload && payload.reason === "hold") {
        console.log("MuteAudio due to hold, not sending event");
        return;
      }
      await sendEvent("AudioMute");
    });

    scopedActionEmitter.on(Actions.UnmuteAudio, async (payload) => {
      if (payload && payload.reason === "hold") {
        console.log("UnmuteAudio due to hold, not sending event");
        return;
      }
      await sendEvent("AudioUnmute");
    });

    scopedActionEmitter.on(Actions.MuteVideo, async (payload) => {
      if (payload && payload.reason === "hold") {
        console.log("MuteVideo due to hold, not sending event");
        return;
      }
      await sendEvent("VideoMute");
    });

    scopedActionEmitter.on(Actions.UnmuteVideo, async (payload) => {
      if (payload && payload.reason === "hold") {
        console.log("UnmuteVideo due to hold, not sending event");
        return;
      }
      await sendEvent("VideoUnmute");
    });

    scopedEventEmitter.on(Events.ScreenShareStarted, async () => {
      await sendEvent("ScreenShareStarted");
    });

    scopedEventEmitter.on(Events.ScreenShareFinished, async () => {
      await sendEvent("ScreenShareFinished");
    });
  });
}
